import { useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar, MobileMenuButton } from "./sidebar";

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleCloseSidebar = useCallback(() => {
    setSidebarOpen(false);
  }, []);

  const handleOpenSidebar = useCallback(() => {
    setSidebarOpen(true);
  }, []);

  return (
    <div className="flex h-screen bg-background">
      <Sidebar isOpen={sidebarOpen} onClose={handleCloseSidebar} />
      <div className="flex-1 flex flex-col overflow-hidden lg:overflow-auto">
        {/* Mobile header with menu button */}
        <div className="lg:hidden flex items-center h-14 px-4 border-b border-neutral-200 bg-white">
          <MobileMenuButton onClick={handleOpenSidebar} />
          <div className="flex items-center gap-2 ml-3">
            <div className="w-6 h-6 bg-black rounded flex items-center justify-center p-1">
              <img src="/images/logo-brld.svg" alt="BRLD" className="w-full h-full invert" />
            </div>
            <span className="font-semibold text-neutral-900">BRLD</span>
          </div>
        </div>
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
